export default __webpack_public_path__ + "static/nannoditLogo-26b8835f3bc37b9d33a20eccf35799fe.png";